import Hexagon from './Hexagon';
import Rect from './Rect';
import Star from './Star';
import Triangle from './Triangle';

export { Hexagon, Rect, Star, Triangle };
